import React from 'react'
import {TopCom,TopSecondCom,NavbarCom,FooterCom} from '../component/common/commmoncomponent'
import NoticeMain from '../component/notice/noticeMain'


const Notice = (props) => {
  return(
        <>
         <TopCom/>
    <TopSecondCom/>
    <NavbarCom/>
    <NoticeMain/>
    <FooterCom/>
        </>
   )

 }

export default Notice